import { ReactElement } from 'react'

import { useAtomValue, useSetAtom } from 'jotai'

import {
  SequenceMenu,
  useNotifications,
  SimpleModal
} from '@sequencehq/core-components'
import { useMutation } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'

import {
  invoiceIdAtom,
  isSavePendingAtom,
  awaitingBulkActionAtom
} from 'Invoices/atoms/invoiceEditing.atom'
import { usePermissions } from 'lib/rbac'

export const MenuItemConvertToDraft = () => {
  const isSavePending = useAtomValue(isSavePendingAtom)

  const { can } = usePermissions()

  if (!can('org.invoice:update')) {
    return null
  }

  return (
    <DialogConvertToDraft
      trigger={
        <SequenceMenu.Item
          uuid="convert-to-draft"
          label="Convert to draft"
          isDisabled={isSavePending}
          data-testid="header.kebab-menu.convert-to-draft"
        />
      }
    />
  )
}

const DialogConvertToDraft = ({ trigger }: { trigger: ReactElement }) => {
  const setAwaitingBulkAction = useSetAtom(awaitingBulkActionAtom)
  const { displayNotification } = useNotifications()

  const invoiceId = useAtomValue(invoiceIdAtom)

  const convertInvoiceToDraftMutation = useMutation(
    dashboardv99990101Client.postConvertInvoiceToDraft,
    {
      onSuccess: () => {
        setAwaitingBulkAction(true)
      },
      onError: () => {
        displayNotification('Something went wrong, please try again', {
          type: 'error'
        })
      }
    }
  )

  return (
    <SimpleModal
      trigger={trigger}
      variant="dialog"
      title="Convert upcoming invoice to draft"
      submitButtonText="Convert to draft"
      submittingButtonText="Converting..."
      onSubmit={async () => {
        if (!invoiceId) return false
        const res = await convertInvoiceToDraftMutation.mutateAsync({
          id: invoiceId
        })
        return Boolean(res)
      }}
      data-testid="modal.convert-to-draft"
    >
      You will be able to finalize and send the invoice once it is drafted. You
      cannot convert this invoice back to upcoming.
    </SimpleModal>
  )
}
